import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";

export const MapGroupPermissions = [DispatcherPermissionValue.ViewTrucksOnMap];
